import React from "react";
import TextInput from "../../../components/TextInput";
import styles from "./ProfileInformation.module.sass";
import { useUser } from "../../../context";
import settings from "../../../i11/Settings";

const Location = ({ data, setAddress }) => {
	const { locale } = useUser();
	return (
		<>
			<TextInput
				className={styles.field}
				label={settings[locale].addressline}
				name="location"
				type="text"
				tooltip="Brand contact address"
				required
				defaultValue={data ? data.address?.AddressLine ?? "" : ""}
				onChangeInput={(e) =>
					setAddress((p) => {
						return { ...p, AddressLine: e };
					})
				}
			/>
			<TextInput
				className={styles.field}
				label={settings[locale].city}
				name="location"
				type="text"
				tooltip="Brand contact address"
				required
				defaultValue={data ? data.address?.City ?? "" : ""}
				onChangeInput={(e) =>
					setAddress((p) => {
						return { ...p, City: e };
					})
				}
			/>
			<TextInput
				className={styles.field}
				label={settings[locale].postal}
				name="location"
				type="text"
				tooltip="Brand contact address"
				required
				defaultValue={data ? data.address?.PostalCode ?? "" : ""}
				onChangeInput={(e) =>
					setAddress((p) => {
						return { ...p, PostalCode: e };
					})
				}
			/>
			<TextInput
				className={styles.field}
				label={settings[locale].country_code}
				name="location"
				type="text"
				tooltip="Brand contact address"
				required
				defaultValue={data ? data.address?.CountryCode ?? "" : ""}
				onChangeInput={(e) =>
					setAddress((p) => {
						return { ...p, CountryCode: e };
					})
				}
			/>
			<TextInput
				className={styles.field}
				label={settings[locale].state}
				name="location"
				type="text"
				tooltip="Brand contact address"
				required
				defaultValue={data ? data.address?.StateProvinceCode ?? "" : ""}
				onChangeInput={(e) =>
					setAddress((p) => {
						return { ...p, StateProvinceCode: e };
					})
				}
			/>
		</>
	);
};

export default Location;
